import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ActionTree, GetterTree } from "vuex";
import _ from "@/boot/lodash";
import type {
  ApiPathGetter,
  IProvisionCategory
} from "@upmind-automation/types";
import type { IState } from "@/store";

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath:
    (): ApiPathGetter =>
    ({ categoryCode }: { categoryCode?: IProvisionCategory["code"] }) => {
      const admin = `api/admin/provision/categories/${categoryCode}/configurations`;
      return { admin };
    },
  scope: () => {
    return `$provision_category_configurations`;
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: `${getters.apiPath(payload.params).admin}`,
        splitCount: true,
        storeModule: DataModules.PROVISIONING_CATEGORY_CONFIGURATIONS,
        params: _.omit(payload.params, ["categoryCode"])
      },
      { root: true }
    );
  },
  openConfigurationsListingModal: ({ dispatch }, payload) => {
    return dispatch(
      "ui/open/modal",
      {
        config: {
          component: () =>
            import(
              "@/components/app/admin/provisioning/provisionConfigurationsListingModal.vue"
            ),
          ...payload
        }
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
